import { formatDt } from "../lib/utils";
import React, { Component } from "react";

const ToLocalDate = ({ time }) => formatDt(time);
export default ToLocalDate;

